import { z } from 'zod';
import { api } from './api';

const BASE_URL = import.meta.env.VITE_API_URL ?? '/api/v1';

/** The company's background photo. `custom: false` is the built-in one. */
export const brandingSchema = z.object({
  custom: z.boolean(),
  version: z.string().nullable().optional().default(null),
  updated_at: z.string().nullable().optional().default(null),
});

export type Branding = z.infer<typeof brandingSchema>;

/** The photo that ships with the web app (public/backgrounds). */
export const DEFAULT_BACKGROUND_URL = '/backgrounds/ramen-ten.jpg';

export const brandingService = {
  get: (signal?: AbortSignal): Promise<Branding> => api.get('/branding', brandingSchema, signal),

  /** Owner only; the server refuses everyone else. */
  uploadBackground: (file: File): Promise<Branding> => {
    const form = new FormData();
    form.append('file', file);
    return api.upload('/branding/background', brandingSchema, form);
  },

  /** Owner only. Back to the built-in photo. */
  resetBackground: (): Promise<Branding> => api.delete('/branding/background', brandingSchema),

  /** Where the current photo is drawn from. The version is part of the URL,
   *  so a browser keeps the photo cached and still sees a new one at once. */
  backgroundUrl: (branding: Branding | undefined): string =>
    branding?.custom && branding.version
      ? `${BASE_URL}/branding/background?v=${encodeURIComponent(branding.version)}`
      : DEFAULT_BACKGROUND_URL,
};
